import thumbnail_scl from '../../assets/scl/thumbnail.png';

import image0 from '../scl/0.png';
import image1 from '../scl/1.png';
import image2 from '../scl/2.png';
import image3 from '../scl/3.png';
import image4 from '../scl/4.png';
import image5 from '../scl/5.png';
import image6 from '../scl/6.png';

export const SCLApp = {
  id: 8,
  type: 'mobile',
  thumbnails: [thumbnail_scl],
  screens: [image0, image1, image2, image3, image4, image5, image6],
  title: 'SCL – Social Interaction Learning App for Children',
  intro:
    "SCL (Social and Communication Learning) is a thoughtfully designed mobile app that helps children develop essential social skills and ethical behavior through engaging activities, storytelling, and guided interactions. Created in collaboration with educators and psychologists, SCL makes learning empathy, manners, and respect both fun and effective.",
  features: [
    {
      title: "Interactive Social Scenarios",
      description:
        "Children can explore real-life social situations — like sharing, helping others, or resolving conflicts — through gamified experiences and animated stories."
    },
    {
      title: "Age-Appropriate Learning Paths",
      description:
        "Customized learning journeys are tailored to different age groups, ensuring content is developmentally appropriate and relatable."
    },
    {
      title: "Visual and Audio-Based Lessons",
      description:
        "With colorful visuals, character voices, and friendly narration, kids stay engaged while absorbing social values and good behavior."
    },
    {
      title: "Mini-Games That Teach Empathy",
      description:
        "From role-playing to scenario-based puzzles, SCL’s mini-games help children understand emotions, practice kindness, and develop empathy."
    },
    {
      title: "Progress Tracking for Parents",
      description:
        "Parents and guardians can track their child’s learning progress, completed lessons, and emotional development through a secure dashboard."
    },
    {
      title: "Safe and Child-Friendly Design",
      description:
        "The app ensures a completely ad-free, distraction-free, and safe learning environment designed specifically for young users."
    },
    {
      title: "Offline Learning Support",
      description:
        "Key lessons and games are downloadable for offline access — so learning doesn’t stop, even without internet."
    }
  ],
  conclusion:
    "SCL empowers children to grow into socially aware and emotionally intelligent individuals. Whether at home or in the classroom, the app brings foundational ethics and empathy-building right to their fingertips. Download SCL today and help your child build better relationships — one lesson at a time."
};
